import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {
  isTelephonyCallLive,
  TelephonyCall,
  useGetTelephonyCurrentCallQuery,
} from '@dms/api/settings';

import {useTelephonyCallAvailability} from './useTelephonyCallAvailability';

/** A live outbound call keeps the viewer busy; an inbound one only once the viewer answered it. */
const isViewerOnCall = (call: TelephonyCall) =>
  call.direction === 'outbound' ? isTelephonyCallLive(call) : call.status === 'in_call';

/**
 * The viewer's current call as the shared cache sees it. Reads only: the top-bar indicator keeps
 * the entry fresh through `useTelephonyCallPushSync`, every other consumer (the Call button
 * disabling itself while the viewer is on a call) just subscribes here.
 */
export function useCurrentTelephonyCall() {
  const {isAllowed} = useTelephonyCallAvailability();

  const {data: call, refetch} = useGetTelephonyCurrentCallQuery(isAllowed ? undefined : skipToken);

  return {
    call: call ?? null,
    isOnCall: isNotNil(call) && isViewerOnCall(call),
    refetch,
  };
}
